module.exports = __webpack_public_path__ + "img/be.6d44f4d2.svg";